import { ApiRequestError } from '../../api/client';
import { Icon } from './Icon';

/** Polite error block. Shows the correlation id so a user can quote it to IT. */
export function ErrorBanner({ error, title }: { error: Error | string; title?: string }) {
  const message = typeof error === 'string' ? error : error.message;
  const correlationId = error instanceof ApiRequestError ? error.correlationId : null;
  const code = error instanceof ApiRequestError ? error.code : null;
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm"
    >
      <Icon name="alert" className="mt-0.5 shrink-0 text-destructive" />
      <div>
        {title ? <p className="font-medium">{title}</p> : null}
        <p>{message}</p>
        {correlationId ? (
          <p className="mt-1 text-xs text-muted-foreground">
            {code ? `${code} · ` : ''}Reference <code className="gsl-num">{correlationId}</code>
          </p>
        ) : null}
      </div>
    </div>
  );
}
